export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";